import { useEffect, useState } from 'react';

/**
 * SVGグラフの座標幅を実表示幅へ合わせ、狭い画面でも文字を縮小・変形させない。
 * CSS側の表示幅とviewBox幅を同じ値にすることで、軸ラベルは指定したpx相当を保つ。
 */
export default function useResponsiveChartWidth(elementRef, fallbackWidth) {
  const [width, setWidth] = useState(fallbackWidth);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return undefined;

    const update = (candidate) => {
      const next = Math.round(Number(candidate) || element.getBoundingClientRect().width || 0);
      if (next > 0) setWidth((current) => (current === next ? current : next));
    };

    update();
    if (typeof ResizeObserver !== 'function') {
      window.addEventListener('resize', update, { passive: true });
      return () => window.removeEventListener('resize', update);
    }

    const observer = new ResizeObserver((entries) => {
      update(entries[0]?.contentRect?.width);
    });
    observer.observe(element);
    return () => observer.disconnect();
  });

  return width;
}
